import { createContext, useContext, useState } from "react";
import { yearRange } from "@/lib/format";

const DateRangeContext = createContext(null);

export function DateRangeProvider({ children }) {
  // Start every new page load with the current calendar year. The selection
  // remains editable for the rest of the session, but is intentionally not persisted.
  const [range, setRange] = useState(() => yearRange());
  return (
    <DateRangeContext.Provider value={{ range, setRange }}>
      {children}
    </DateRangeContext.Provider>
  );
}

export const useDateRange = () => useContext(DateRangeContext);
